import defaultNavigation from '../../../../contracts/native-sportsbook/v1/home-navigation.json'
import { activeCards, eventMatchesManifestScope, liveGameEventCandidates, outcomeReference, parlayLegs, spotlightEventCandidates, sportGlyph } from './nativePreviewModel'

export const NAVIGATION_CAPABILITY = 'home.navigation.v1'
export const NAVIGATION_LABELS = { sports: 'Sports navigation', filters: 'Quick filters' }
export const NAVIGATION_ICONS = { auto: 'Automatic', trophy: 'Trophy', bolt: 'Lightning', star: 'Sparkle', clock: 'Clock', football: 'Football', soccer: 'Soccer', basketball: 'Basketball', baseball: 'Baseball', hockey: 'Hockey', tennis: 'Tennis' }
const GLYPHS = { trophy: '🏆', bolt: 'ϟ', star: '✦', clock: '◷', football: '🏈', soccer: '⚽', basketball: '🏀', baseball: '⚾', hockey: '🏒', tennis: '🎾' }
export const navigationDefaults = () => structuredClone(defaultNavigation)
export const navigationGlyph = (item) => GLYPHS[item.icon] || sportGlyph(item.scope)
export function navigationMatches(event, item) {
  if (!item) return true
  return (item.scope === 'all' || eventMatchesManifestScope(event, item.scope)) &&
    (item.predicate === 'all' || (item.predicate === 'live' ? Boolean(event.live) : !event.live))
}
// The caller supplies components visible in the preview's jurisdiction/session.
// Lists and independently authored cards both contribute approved Home inventory.
export function navigationInventory(components, events, now = new Date(), collections = {}) {
  const catalog = { events }
  const included = new Set()
  const include = (candidates) => candidates.forEach((event) => included.add(event.id))
  for (const component of components.filter((candidate) => candidate.enabled !== false)) {
    if (component.type === 'event_list') {
      if (component.collection) { include(collections[component.collection.id]?.events || []); continue }
      include(events.filter((event) => component.event_ids?.includes(event.id) || component.sport_ids?.some((scope) => eventMatchesManifestScope(event, scope))))
    } else if (component.type === 'live_game_momentum') {
      include(liveGameEventCandidates(component, catalog))
    } else if (component.type === 'featured_showcase') {
      for (const card of activeCards(component, now)) {
        if (card.kind === 'event_spotlight') include(spotlightEventCandidates(card, catalog, now))
        if (card.kind === 'odds_boost') {
          const reference = outcomeReference(catalog, card)
          if (reference) include([reference.event])
        }
        if (card.kind === 'parlay_suggestion') {
          const legs = parlayLegs(card, catalog)
          if (legs.length >= 2) include(legs.map((leg) => leg.event))
        }
      }
    }
  }
  return events.filter((event) => included.has(event.id))
}
export function navigationOptions(bar, events) {
  if (!bar?.enabled) return []
  const options = bar.items.filter((item) => item.enabled).map((item) => {
    const matches = events.filter((event) => navigationMatches(event, item))
    return { ...item, count: matches.length, liveCount: matches.filter((event) => event.live).length }
  }).filter((item) => !bar.hide_empty || item.count > 0 || (item.scope === 'all' && item.predicate === 'all'))
  if (bar.order !== 'live_first') return options
  return options.map((item, index) => ({ ...item, index })).sort((a, b) => {
    const allA = a.scope === 'all' && a.predicate === 'all', allB = b.scope === 'all' && b.predicate === 'all'
    return Number(allB) - Number(allA) || b.liveCount - a.liveCount || a.index - b.index
  })
}
export const navigationSelection = (id, options) => options.find((item) => item.id === id) || options[0] || null
export function resolveHomeNavigation(navigation, components, events, sportId, filterId, collections = {}) {
  const inventory = navigationInventory(components, events, new Date(), collections)
  const sports = navigationOptions(navigation.sports, inventory)
  const sport = navigationSelection(sportId, sports)
  const sportEvents = inventory.filter((event) => navigationMatches(event, sport))
  const filters = navigationOptions(navigation.filters, sportEvents)
  const filter = navigationSelection(filterId, filters)
  return { inventory, sports, sport, filters, filter, events: sportEvents.filter((event) => navigationMatches(event, filter)) }
}
export function navigationPreset(current, preset) {
  const next = structuredClone(current || defaultNavigation)
  next.sports.order = preset === 'live' ? 'live_first' : 'manual'
  next.sports.style = preset === 'classic' ? 'pill' : 'underline'
  next.sports.show_counts = preset === 'live'
  next.sports.hide_empty = preset !== 'classic'
  next.filters.style = 'pill'
  next.filters.show_icons = false
  next.filters.show_counts = preset !== 'classic'
  next.filters.hide_empty = preset === 'live'
  next.filters.order = 'manual'
  if (preset === 'live') next.filters.items.sort((a, b) => Number(b.predicate === 'live') - Number(a.predicate === 'live'))
  else next.filters.items.sort((a, b) => Number(b.predicate === 'all' && b.scope === 'all') - Number(a.predicate === 'all' && a.scope === 'all'))
  return next
}
